var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.7,
    y: 198.49,
    width: 6.73,
    height: 184.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.31,
    y: 221.87,
    width: 6.73,
    height: 160.78,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.67,
    y: 245.25,
    width: 6.73,
    height: 137.4,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.04,
    y: 229.66,
    width: 6.73,
    height: 152.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.41,
    y: 221.87,
    width: 6.73,
    height: 160.78,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.77,
    y: 206.28,
    width: 6.73,
    height: 176.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.14,
    y: 214.08,
    width: 6.73,
    height: 168.57,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.51,
    y: 206.28,
    width: 6.73,
    height: 176.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.87,
    y: 190.69,
    width: 6.73,
    height: 191.95,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.24,
    y: 175.11,
    width: 6.73,
    height: 207.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.6,
    y: 159.52,
    width: 6.73,
    height: 223.13,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,234.3a1.52,1.52,0,0,1-1-.43l-56.34-54.93a1.5,1.5,0,0,1,2.1-2.15l55.43,54.05,78.07-57a1.51,1.51,0,0,1,2,.22L304.82,203l105.8-60.62a1.5,1.5,0,1,1,1.49,2.61L305.25,206.23a1.51,1.51,0,0,1-1.87-.31l-25.46-28.8-78,56.89A1.5,1.5,0,0,1,199,234.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.65 381.5 143.48 187.59 145.94 177.9 143.38 177.9 143.38 122.52 136.78 122.52 136.78 177.9 134.22 177.9 136.68 187.59 87.5 381.5 94.31 381.5 136.78 214.02 136.78 382.52 143.38 382.52 143.38 214.02 185.85 381.5 192.65 381.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.08,
    cy: 176.93,
    r: 38.07,
    transform: "translate(-64.3 272.61) rotate(-76.72)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.08,
    cy: 176.93,
    r: 32.5,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.08,
    cy: 176.93,
    r: 25.44,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.08,
    cy: 176.93,
    r: 20.85,
    transform: "translate(-57.04 67.07) rotate(-22.5)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.08,
    cy: 176.93,
    r: 14.47,
    transform: "translate(-64.3 272.61) rotate(-76.72)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.08,
    cy: 176.93,
    r: 10.39,
    transform: "translate(-57.04 67.07) rotate(-22.5)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.79,176.93a4.72,4.72,0,1,1-4.71-4.72A4.71,4.71,0,0,1,144.79,176.93Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.22 145.53 92.25 152.41 85.09 154.82 92.25 158.58 99.39 156.07 98.14 149.29 91.22 145.53",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.08,177.93a1.07,1.07,0,0,1-.46-.11L88.39,151.56a1,1,0,0,1,.91-1.78L140.53,176a1,1,0,0,1,.44,1.34A1,1,0,0,1,140.08,177.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.58,134.16a8.79,8.79,0,0,1,11.35-8.44,18.66,18.66,0,0,1,18.48-21.38,18.47,18.47,0,0,1,3.43.32,16.32,16.32,0,0,1,30.26,8.25h.28a15,15,0,1,1,0,30.08H219.14v0A8.81,8.81,0,0,1,210.58,134.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.47,129.32a4.25,4.25,0,0,1,4.25-4.25,4.5,4.5,0,0,1,1.22.18,9.36,9.36,0,0,1-.1-1.3,9,9,0,0,1,10.66-8.85,7.87,7.87,0,0,1,14.58,4h.13a7.25,7.25,0,0,1,0,14.5H371.6A4.24,4.24,0,0,1,367.47,129.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,134.61a2.85,2.85,0,0,1,2.86-2.85,2.81,2.81,0,0,1,.82.12,6.4,6.4,0,0,1-.07-.88,6.05,6.05,0,0,1,6-6,6,6,0,0,1,1.12.11,5.28,5.28,0,0,1,9.8,2.67h.09a4.88,4.88,0,0,1,0,9.75H97.5A2.85,2.85,0,0,1,94.72,134.61Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-6",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.38,225.56l6.86-3.92s2.64-4.07,3.43-4.26,9.49,0,9.49,0-1.31,5.64-1.45,6.75-8.44,0-8.44,0l-6.72,4Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.49,408l-7.18-1.43a.56.56,0,0,0-.55.44l-1.93,7.18a1,1,0,0,0,.73,1.13l.21,0c2.54,0,4.39-.2,7.57-.2,2,0,7.88.21,10.59.21s3.07-2.68,2-2.92c-5-1.09-8.72-2.59-10.31-4A1.58,1.58,0,0,0,74.49,408Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.36,407.76h-7.84a.55.55,0,0,0-.55.44L152.69,414a1,1,0,0,0,.74,1.12l.21,0c2.54-.05,4.38-.2,7.57-.2,2,0,7.88.2,10.59.2s3.06-2.67,1.95-2.92c-5-1.08-8.72-2.59-10.31-4A1.49,1.49,0,0,0,162.36,407.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.33,275.67l33.2-8.42c7.53,16.44,35.16,83.94,41.86,140.1l-11.24,2.85s-19.9-82.82-36.59-107c0,0-.89,36.76-2.7,42.11-1.49,4.4-35.66,63.27-35.66,63.27l-11.1-1.25S94,347.25,95.64,339.76c1.16-5.1-3.92-42.56-3.92-42.56-.89-3.34-2.23-17.17-2.23-17.17S88.49,276.36,88.33,275.67Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.57,303.22a92.26,92.26,0,0,1,7.35,13.42c-2.3-12.94-9.43-25.47-9.43-25.47Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.33,275.67l33.2-8.42c7.53,16.44,35.16,83.94,41.86,140.1l-11.24,2.85s-19.9-82.82-36.59-107c0,0-.89,36.76-2.7,42.11-1.49,4.4-35.66,63.27-35.66,63.27l-11.1-1.25S94,347.25,95.64,339.76c1.16-5.1-3.92-42.56-3.92-42.56-.89-3.34-2.23-17.17-2.23-17.17S88.49,276.36,88.33,275.67Z",
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.05,226.13s-15.14,10.22-19.13,10.76c-1.59.22-4.87-.32-8.26-1-5.14-1.1-10.5-2.64-10.5-2.64l-.67-5.07-.71-5.42c1.2-.4,16.86,6,19.2,7s17.47-8,17.47-8Z",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "99.23 273.33 100.21 277.17 89.49 280.03 88.49 276.05 99.23 273.33"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.14 269.04 117.07 272.68 101.4 276.86 100.42 273.03 116.14 269.04"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.24 271.04 118.25 272.37 117.33 268.74 121.91 267.58 123.24 271.04"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 106.97,
    y: 269.89,
    width: 6.38,
    height: 4.6,
    transform: "translate(283.83 508.95) rotate(165.77)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.9,267.57l-33.42,8.48c-1.63-4.41-3.29-8.85-4.91-13.18-1.19-3.17-2.36-6.28-3.5-9.29q-.43-1.16-.87-2.28l-1-2.66q-1.11-2.92-2.14-5.63l-1.84-4.81-.87-2.28-1.65-4.3,35.09-8.9C118.36,242.91,121.9,267.57,121.9,267.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.44,230.76c3.61,1.73,10.27-1.32,10.27-1.32s2.21-2.44.89-3.52c-2.68.35-2.51-.53-3.48-1.9A7.89,7.89,0,0,1,91,221.18a16.06,16.06,0,0,1-.27-1.69L80.2,215.71C82.59,219.57,86.3,226.88,84.44,230.76Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,219.16c1.9,5.05,6.56,5.2,8.72,4.86A7.89,7.89,0,0,1,91,221.18Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.12,200s2.75,8.3-1.22,12.35-6.66-11.82-6.66-11.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.92,221.39a7.85,7.85,0,0,0,9.39,1.48A8.76,8.76,0,0,0,97.55,218c.1-.28.19-.58.27-.88,1.34-5.59.5-14.82-5.59-17.3a8.51,8.51,0,0,0-11.73,8.5C80.86,214.55,80.78,218.21,83.92,221.39Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.93,210.09c0,.5.26.91.6.91s.59-.41.6-.91-.27-.92-.6-.92S89.93,209.58,89.93,210.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.65,210.09c0,.51.27.92.6.92s.59-.42.6-.92-.28-.91-.6-.91S95.65,209.61,95.65,210.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.83,210.34a17.83,17.83,0,0,0,2.41,4.33,2.91,2.91,0,0,1-2.43.45Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.74,207.75a.34.34,0,0,1-.31,0,2.38,2.38,0,0,0-2.11-.4.29.29,0,0,1-.21-.55h0a2.92,2.92,0,0,1,2.66.47.29.29,0,0,1,.08.41h0A.52.52,0,0,1,97.74,207.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8,207.82a.38.38,0,0,1-.16-.06.3.3,0,0,1,0-.42h0a2.94,2.94,0,0,1,2.63-.7.3.3,0,0,1,.2.36h0a.31.31,0,0,1-.37.21h0a2.35,2.35,0,0,0-2.06.58A.3.3,0,0,1,88.8,207.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.06,200.6l.6,1.15c-2,.77-1.5,3.13-1,4.18,1,2.26-.15,5.89-1.84,7.4,0,0-.11-1-.94-.72s-.35,5.46,1.41,7.86c0,0-2.59-2.13-4.25-7.51-1.53-5-1.89-9.17-.94-11.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.78,213.44a5.91,5.91,0,0,0,3.39,3c2,.66,3-1.07,2.6-3-.42-1.69-1.93-4.14-4-3.95A2.64,2.64,0,0,0,77.78,213.44Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,223.89c2.94,2.06,8.67,2.73,11.48-1s1.91-9.72,1.91-9.72a9.33,9.33,0,0,1-1.8,3.66C95,214.91,92.3,216,92.3,216a3.89,3.89,0,0,0-2.3-1.44c-1.31-.13-5,.09-5,.09-1.18-.75-1.23-4.09-1.23-4.09l-.72.6S82.05,221.82,85,223.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.86,202.72s7-3.4,6.17-6.8-2.87.48-2.87.48.94-2.58-.9-3S94,194.63,93,195.62s-10.7-.45-13.83,1.49-.74,8.65-.74,8.65A13.46,13.46,0,0,1,92.86,202.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,223.89c2.94,2.06,8.67,2.73,11.48-1s1.91-9.72,1.91-9.72a9.33,9.33,0,0,1-1.8,3.66C95,214.91,92.3,216,92.3,216a3.89,3.89,0,0,0-2.3-1.44c-1.31-.13-5,.09-5,.09-1.18-.75-1.23-4.09-1.23-4.09l-.72.6S82.05,221.82,85,223.89Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6,217.9a18.4,18.4,0,0,0-1.45,2.27L90.7,220c-2-.73-2.72-1.73-2.88-2.63a2.84,2.84,0,0,1,.11-1.3,2.91,2.91,0,0,1,.31-.69,10.18,10.18,0,0,0,3.68,2.25C92.33,217.81,92.6,217.9,92.6,217.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.92,217.64l-.45.66c-1.9-.69-3.15-1.43-3.54-2.22a2.91,2.91,0,0,1,.31-.69A10.18,10.18,0,0,0,91.92,217.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,220c-2-.73-2.72-1.73-2.88-2.63a7.15,7.15,0,0,1,2.09,1.26A2.57,2.57,0,0,1,90.7,220Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.03 229.45 95.44 234.63 106.24 257.64 105.17 260.69 101.64 259.06 93.94 235.59 88.28 231.76 92.4 229.5 96.03 229.45",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.68 225.91 91.83 228.86 92.12 224.02 97.39 225.32 97.84 232.69 92.77 230.62 90.65 235.34 81.64 229.32 84.68 225.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.68 225.91 91.83 228.86 92.12 224.02 97.39 225.32 97.84 232.69 92.77 230.62 90.65 235.34 81.64 229.32 84.68 225.91",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.19,248.64q-1.11-2.92-2.14-5.63l-1.84-4.81-.87-2.28c1-.49,3.55-.2,4.26,1C80.2,241.46,78.19,248.64,78.19,248.64Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.72,253.72a13.37,13.37,0,0,1-7.15,9.15c-1.19-3.17-2.36-6.28-3.5-9.29q-.43-1.16-.87-2.28l-1-2.66,11.58,1.47Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.66,235.85c-5.14-1.1-10.5-2.64-10.5-2.64l-.67-5.07S116.94,229.15,118.66,235.85Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.69,354a1.5,1.5,0,0,1-1-2.66c16.69-13.7,16.37-35.17,16.06-55.94-.24-15.66-.46-30.46,6.91-40.52,10.34-14.14,51.93-36.57,58.82-37.21,4.93-.49,155.3-42.28,234.13-64.31a1.5,1.5,0,0,1,.81,2.89c-9.33,2.61-228.48,63.84-234.66,64.41-5.93.55-47.1,22.89-56.68,36-6.77,9.25-6.56,23.56-6.33,38.7.3,20.48.65,43.7-17.16,58.31A1.48,1.48,0,0,1,71.69,354Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.47,156.24,366.91,162c-56.55,15.78-209,58.2-214.1,58.67-5.93.55-47.1,22.89-56.68,36-6.77,9.25-6.56,23.56-6.33,38.7.3,20.48.65,43.7-17.16,58.31a1.48,1.48,0,0,1-1,.34,1.5,1.5,0,0,1-1-2.66c16.69-13.7,16.37-35.17,16.06-55.94-.24-15.66-.46-30.46,6.91-40.52,10.34-14.14,51.93-36.57,58.82-37.21,4.64-.46,137.86-37.44,219.28-60.16l14.85-4.15a1.5,1.5,0,0,1,.81,2.89Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.47,156.24,366.91,162a26.8,26.8,0,0,1,4.9-4.48l14.85-4.15a1.5,1.5,0,0,1,.81,2.89Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.91,250.8l7.86-.69s4.11-2.6,4.9-2.43,8.62,4,8.62,4-3.55,4.57-4.14,5.52-7.66-3.53-7.66-3.53l-7.79.83Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.69,231.62c-3.57,2.55-12.87,23.34-11.88,26.55s29.93-3.12,29.93-3.12l-1.28-5.41H72.89l3.7-5.84s2.28-2.22.88-7.38C76.46,232.7,71.69,231.62,71.69,231.62Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.21,233.71l-5.93-2.81s-3-5.74-3.88-6.66-5.13,2.65-5.13,3.27,3.08,6.42,3.88,6.77a12.35,12.35,0,0,0,3.59,0l5.64,2.73Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.05,198.14l1.19-4.25s1.88-5.54,1.68-6.82a33,33,0,0,0-1.42-4.45s-5.2,6.33-5.2,7.12,2.06,3.66,2.06,3.66l-1,4.74Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.62,229.8s-4.48-5.57-5.8-10.75,2.67-22,2.67-22l-4.21-1.12s-5,17.21-5.17,23.49,9.17,24.71,9.17,24.71Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,241.36l-.64,2.73s-3.22-6.35-5.85-12.87a16.38,16.38,0,0,1,5.91,7.91A14.09,14.09,0,0,1,388.91,241.36Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.34,242a24.16,24.16,0,0,1-.42,3.46c-.46,2.5-1.24,5.45-2.13,8.7-.48,1.71-1,3.54-1.46,5.47-2.23,8.67-3.44,12.12-5.09,23.19l-31.65-7.51a151.78,151.78,0,0,1,7.79-27.75c.92-2.39,2-4.78,3.09-7.14a72.61,72.61,0,0,1,6.15-10.6s5.12,4.68,21.2,7.49C414.77,237.61,415.44,239.31,415.34,242Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.36,238.39c0,1,3.79,5.76,3.56,7-.43.29-.94.61-1.52,1-10.71,6.23-24.76,3.07-31,1.14.92-2.39,3-6.78,4.08-9.14l7.51,1.67S406.27,237.26,411.36,238.39Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.49,231.71c1.15-.44,10.59,1.91,9.89,2.11s-4.22,11-9.15,10.19S394.39,233.27,398.49,231.71Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.75 408.66 349.81 409.95 346.34 396.29 352.29 395 355.75 408.66",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.33,407.47h7.39a.52.52,0,0,1,.51.42l1.2,5.41a.89.89,0,0,1-.69,1.07l-.2,0c-2.39,0-4.13-.19-7.13-.19-1.85,0-7.43.19-10,.19s-2.88-2.52-1.84-2.75c4.69-1,8.22-2.44,9.72-3.78A1.43,1.43,0,0,1,348.33,407.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.32,408.54a1.85,1.85,0,0,1-1.17-.31.84.84,0,0,1-.3-.77.43.43,0,0,1,.24-.41c.68-.35,2.64.86,2.86,1a.13.13,0,0,1,.07.14.14.14,0,0,1-.11.12A7.18,7.18,0,0,1,346.32,408.54Zm-.91-1.26a.28.28,0,0,0-.18,0s-.09.05-.1.17a.59.59,0,0,0,.2.51,2.93,2.93,0,0,0,2.16.11A5.79,5.79,0,0,0,345.41,407.28Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.87,408.32h-.07c-.62-.34-1.84-1.68-1.72-2.32a.48.48,0,0,1,.47-.38.76.76,0,0,1,.61.19c.7.57.85,2.32.86,2.4a.14.14,0,0,1-.07.13A.08.08,0,0,1,347.87,408.32Zm-1.22-2.47h-.07c-.19,0-.2.11-.21.15-.08.4.7,1.41,1.32,1.88A3.37,3.37,0,0,0,347,406,.48.48,0,0,0,346.65,405.85Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.5,283.65s-5.13,24.46-17.13,31a12.76,12.76,0,0,1-4.45,1.51s-12.17,5-22.69,9.73c-6.4,2.89-12.19,5.71-14.26,7.29-5.48,4.17,7.94,69.27,7.94,69.27l-9.12.1s-19.19-57.64-16-72.77,37.63-38.29,37.63-38.29l5.3-14.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.37,314.68a12.76,12.76,0,0,1-4.45,1.51s-12.17,5-22.69,9.73c6.77-12.45,18.84-20.54,18.84-20.54Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.21 408.66 426.27 409.95 422.8 396.29 428.75 395 432.21 408.66",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.79,407.47h7.39a.52.52,0,0,1,.51.42l1.2,5.41a.89.89,0,0,1-.69,1.07l-.2,0c-2.39,0-4.13-.19-7.13-.19-1.85,0-7.43.19-10,.19s-2.88-2.52-1.84-2.75c4.69-1,8.22-2.44,9.72-3.78A1.43,1.43,0,0,1,424.79,407.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.78,408.54a1.85,1.85,0,0,1-1.17-.31.84.84,0,0,1-.3-.77.43.43,0,0,1,.24-.41c.68-.35,2.64.86,2.86,1a.13.13,0,0,1,.07.14.14.14,0,0,1-.11.12A7.18,7.18,0,0,1,422.78,408.54Zm-.91-1.26a.28.28,0,0,0-.18,0s-.09.05-.1.17a.59.59,0,0,0,.2.51,2.93,2.93,0,0,0,2.16.11A5.79,5.79,0,0,0,421.87,407.28Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.33,408.32h-.07c-.62-.34-1.84-1.68-1.72-2.32a.48.48,0,0,1,.47-.38.76.76,0,0,1,.61.19c.7.57.85,2.32.86,2.4a.14.14,0,0,1-.07.13A.08.08,0,0,1,424.33,408.32Zm-1.22-2.47H423c-.19,0-.2.11-.21.15-.08.4.7,1.41,1.32,1.88a3.37,3.37,0,0,0-.72-1.9A.48.48,0,0,0,423.11,405.85Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.55,236.89c-1.49,1-8.36.62-8.36.62L397,241l-.31-5.77s-2.15-.89-1.56-1.51a5.63,5.63,0,0,0,4.14-1.39c1.39-1.36,1.66-3.55,1.64-5.72,0,0,0-.06,0-.08h0l5.87-3,4.06-2.09C408.93,225.56,406.2,233.29,408.55,236.89Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.72,224.9c-1.94,4.91-7,7.1-9.49,7.42,1.39-1.36,1.66-3.55,1.64-5.72a.28.28,0,0,0,0-.09l5.87-3C406.75,224.31,409,224.15,408.72,224.9Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.45,224.7s3.81,2,5.08-.39-.54-2.53,1.33-3.39,4.53-1.46,3.92-3.27-2.5-2-.4-4,2.56-4.82-.58-5.37-1.94-3-2.1-4-1.92-1.7-3.83-1.3-2.71-2.43-3.89-3.31-2.81.2-3.24,1.39-1.56-.39-3.24-.59-1.29,1.57-1.81,3.22-1.55.58-2.75,1.94S399.63,216.27,412.45,224.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.11,219c-2.87,4.5-4.5,7.47-7.72,8.93a9.57,9.57,0,0,1-1.34.5c-6.26,1.84-11.42-4.19-9.77-10.16a20.62,20.62,0,0,1,1.2-3.14c2.24-4.69,6.55-9.49,11.7-8.86a8.23,8.23,0,0,1,7.24,9.13A8.34,8.34,0,0,1,414.11,219Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.3,216c-.21.45-.66.65-.94.5s-.31-.64-.08-1.06.67-.65.94-.5S405.54,215.59,405.3,216Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.45,213.33a.76.76,0,0,1-.94.49c-.27-.16-.31-.63-.07-1.06s.66-.65.94-.49S400.68,212.92,400.45,213.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.88,214.4a17.74,17.74,0,0,1-4.09,2.52,2.82,2.82,0,0,0,1.84,1.53Z",
    style: {
      fill: "#892b29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,214.88a.3.3,0,0,1-.28-.11,2.28,2.28,0,0,0-1.82-1,.29.29,0,1,1,0-.57h0a2.82,2.82,0,0,1,2.31,1.23.28.28,0,0,1-.05.4h0A.35.35,0,0,1,408.2,214.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.8,221.13h0a4.39,4.39,0,0,0,4-.67.16.16,0,0,0,0-.21.15.15,0,0,0-.21,0h0a4.23,4.23,0,0,1-3.74.6.13.13,0,0,0-.18.09v0a.13.13,0,0,0,.09.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,209.18a.32.32,0,0,1,0-.17.29.29,0,0,1,.38-.14h0a2.86,2.86,0,0,1,1.64,2.07.29.29,0,0,1-.25.32h0a.29.29,0,0,1-.32-.25h0a2.31,2.31,0,0,0-1.32-1.61A.32.32,0,0,1,400,209.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.12,206.69c1.46.18,2.18,2,2.18,2a32.68,32.68,0,0,1,5.1,2.38,3.44,3.44,0,0,1,1.18,3.43c-.05.48-1.23.92-1.23.92s-2.16,5.1-2.75,6.51l.3,4.71a24.91,24.91,0,0,0,9.17-10.33c3.41-7.1-10.82-13.35-10.82-13.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.25,226.12a5.74,5.74,0,0,1-4.35.48c-1.93-.58-1.82-2.56-.39-3.83,1.28-1.1,3.85-2.19,5.34-.91A2.55,2.55,0,0,1,413.25,226.12Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.38,233.82l-7.95,2.29L397,240.76l.93-5.69s-.85-1.31.56-3.36l-4.84,1-2.92,4.88,5.68-1.33.39,5.67,3.31-3.9,2.71,4.28,8.06-5.11Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.38,233.82l-7.95,2.29L397,240.76l.93-5.69s-.85-1.31.56-3.36l-4.84,1-2.92,4.88,5.68-1.33.39,5.67,3.31-3.9,2.71,4.28,8.06-5.11Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "375.01 272 373.77 276.94 406.49 283.65 406.98 278.16 375.01 272"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.62,274.59c-.26-.37-7.54-1.94-8.23-1.42,0,0-1.41,4.87-1.17,5.38s7.32,1.5,8,1.64S389.88,275,389.62,274.59Zm-2,5c-.54-.11-6.36-.92-6.56-1.34s1-4.42,1-4.42c.57-.43,6.55.86,6.76,1.16S388.16,279.65,387.62,279.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.9,276.25l-1.45-.3a.54.54,0,0,0-.62.38v0a.54.54,0,0,0,.42.68l1.45.28a.54.54,0,0,0,.21-1.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.49,283.65s.63,37-.41,47.8S432,401.36,432,401.36h-8.73s-26.45-43.28-32.51-56.6-10.54-45.1-10.54-45.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.45,239.4c-1.35-3.06-22.08,1.47-23.95.94s-21.33-8.68-21.33-8.68L368.48,236s17.45,10,21.27,11.58,19.09.82,23-.87A5.38,5.38,0,0,0,415.45,239.4Z",
    style: {
      fill: "#1EB445"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.78,159.93l-6.28-40-33.08,23.39,11,4.66c-10.62,24.34-45.07,95.65-104.35,148.23C203.38,363.36,97.44,396.4,96.38,396.72l5.86,19.13c4.5-1.38,111.08-34.58,190.14-104.71,63-55.88,98.42-129.58,109.54-155.38Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.78,152.93l-.28-33-33.08,23.39,11,4.66c-10.62,24.34-45.07,95.65-104.35,148.23C203.38,363.36,97.44,396.4,96.38,396.72l1.86,12.13c4.5-1.38,111.08-31.58,190.14-101.71,63-55.88,96.42-130.58,107.54-156.38Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,161.62a1.47,1.47,0,0,1-.46-.07l-19.21-6.21a1.5,1.5,0,1,1,.92-2.85l19.21,6.2a1.5,1.5,0,0,1-.46,2.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,161.62a1.47,1.47,0,0,1-.46-.07l-19.21-6.21a1.5,1.5,0,1,1,.92-2.85l19.21,6.2a1.5,1.5,0,0,1-.46,2.93Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.93,348.82a1.5,1.5,0,0,1-1.5-1.5c0-47.74,13.87-54,16.47-54.77L229,261.7l.1-.06L398.52,161.18a1.5,1.5,0,0,1,1.53,2.58L230.71,264.19l-44.31,31a1.59,1.59,0,0,1-.63.26c-.11,0-14.34,3.5-14.34,51.9A1.5,1.5,0,0,1,169.93,348.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.93,348.82a1.5,1.5,0,0,1-1.5-1.5c0-47.74,13.87-54,16.47-54.77L229,261.7l.1-.06L398.52,161.18a1.5,1.5,0,0,1,1.53,2.58L230.71,264.19l-44.31,31a1.59,1.59,0,0,1-.63.26c-.11,0-14.34,3.5-14.34,51.9A1.5,1.5,0,0,1,169.93,348.82Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.45,299.28s-7.71,5-13.57,6.51a8.42,8.42,0,0,1-4.49.25c-4.36-1.38-1.77-9.82.83-15.15.42-.87.84-1.65,1.23-2.31l7.62,4.71s-4.62,6.59-4.09,7,7.65-3.56,8-3.69S181.45,299.28,181.45,299.28Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.45,299.28s-7.71,5-13.57,6.51a93.34,93.34,0,0,1-3.66-14.9c.42-.87.84-1.65,1.23-2.31l7.62,4.71s-4.62,6.59-4.09,7,7.65-3.56,8-3.69S181.45,299.28,181.45,299.28Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,270.26l4.52-4A15,15,0,0,1,225,263c.49-.41,8.72-1.05,8.72-1.05s.16,4.35-.49,5.48-7.37,1.62-7.37,1.62l-3.6,3.47Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.08,365.05c-1.29,18.56-4.74,44.9-4.74,44.9l-4.44,1s-4.1-22.05-3.45-42.51a97.91,97.91,0,0,1,1.26-13.31s-15.38-5.91-26.06-11.2c-5.1-2.52-9.13-4.91-9.9-6.45-2.38-4.75,8.44-15.91,8.44-15.91.34.27,6.87,4.43,14.47,9.36,10.09,6.54,22.06,14.44,24,16.41C243.82,348.47,243.72,355.79,243.08,365.05Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.08,365.05a75.15,75.15,0,0,1-12.63,3.37,97.91,97.91,0,0,1,1.26-13.31s-15.38-5.91-26.06-11.2l13-13c10.09,6.54,22.06,14.44,24,16.41C243.82,348.47,243.72,355.79,243.08,365.05Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.46,318.47s42.67,24.53,48.47,30.07,39.28,57.31,39.28,57.31l-2.82,2.69S265.59,384.68,254.5,362l-46-22.23Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,273.18a1.19,1.19,0,0,0,.22.12,9,9,0,0,0,3.4,1.11c3.48.31,5.72-.47,7-2.21h0c1.78-2.58,1.74-6.7.76-11.55a18.55,18.55,0,0,0-1.87-5.56s0-.07,0-.08l-.12-.2a6.72,6.72,0,0,0-5.47-3.38,13.37,13.37,0,0,0-2.93.08C167.49,252.74,168,268.76,176,273.18Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.26,273.3a8.74,8.74,0,0,0,3.39,1c3.47.31,5.7-.59,7-2.34a9.67,9.67,0,0,1-6.11.35A5,5,0,0,0,176.26,273.3Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.62,281.12c-.83,2.68,2.6,4.1,2.6,4.1,6-2,7.35-4.93,7.35-4.93-4.6-3-2.58-9.94-2.58-9.94l-1,.4-7,.74s1.59,3.83,1.77,4.69v0C177.64,280.69,175.62,281.12,175.62,281.12Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.57,255s1.46,6.61-4.47,10.36c0,0-1.75,7.33-5.74,8-5.44.9-11.33-6.19-10.55-14.37C165.83,248.41,181.25,245.4,185.57,255Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,263c-.15-1-1.23-2.68-2.82-2.21s-2,4.74,2.26,5.09C184.09,266,184.35,265.2,184,263Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.35,402.67l-4.6,3.54a.54.54,0,0,0-.15.65l2.34,5a.89.89,0,0,0,1.19.42,1,1,0,0,0,.17-.1c1.86-1.49,1.92-1.72,4.29-3.54,1.45-1.12,6-4.36,8-5.91s.74-3.74-.22-3.29c-4.32,2-8,3.07-10,2.92A1.47,1.47,0,0,0,294.35,402.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.35,402.58a.14.14,0,0,1-.19-.18c.09-.24.91-2.39,1.65-2.52a.43.43,0,0,1,.44.17.85.85,0,0,1,.23.79,1.82,1.82,0,0,1-.73,1A6.9,6.9,0,0,1,295.35,402.58Zm.21-.41a2.91,2.91,0,0,0,1.64-1.4.58.58,0,0,0-.16-.53c-.08-.08-.15-.1-.18-.07a.38.38,0,0,0-.17.08A5.9,5.9,0,0,0,295.56,402.17Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.34,402.63a.16.16,0,0,1-.13-.06c0-.07-1-1.54-.79-2.42a.82.82,0,0,1,.37-.52.48.48,0,0,1,.6,0c.49.43.34,2.22.05,2.87l-.05.05Zm-.67-2.46a3.44,3.44,0,0,0,.59,1.94,3.3,3.3,0,0,0-.1-2.28s-.11-.11-.25,0l-.06,0A.55.55,0,0,0,294.67,400.17Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.12,407l-5.81.11a.54.54,0,0,0-.5.43l-1.09,5.41a.89.89,0,0,0,.71,1,.68.68,0,0,0,.2,0c2.37-.09,2.56-.24,5.55-.3,1.84,0,7.39.05,9.93,0s2.82-2.57,1.78-2.78c-4.69-.92-8.22-2.26-9.74-3.57A1.45,1.45,0,0,0,239.12,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.64,407.64a.13.13,0,0,1-.11-.12.12.12,0,0,1,.06-.14c.21-.14,2.14-1.38,2.82-1.05a.44.44,0,0,1,.26.4.86.86,0,0,1-.29.77,1.77,1.77,0,0,1-1.16.33A7,7,0,0,1,239.64,407.64Zm.41-.21a2.91,2.91,0,0,0,2.15-.15.58.58,0,0,0,.18-.52c0-.11-.06-.16-.09-.16a.43.43,0,0,0-.19,0A5.91,5.91,0,0,0,240.05,407.43Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.6,407.67a.13.13,0,0,1-.07-.13c0-.08.11-1.82.8-2.41a.76.76,0,0,1,.61-.19.47.47,0,0,1,.47.37c.13.63-1,2-1.67,2.34h-.07A.1.1,0,0,1,239.6,407.67Zm.92-2.37a3.46,3.46,0,0,0-.68,1.91c.62-.48,1.37-1.51,1.28-1.9,0,0,0-.14-.21-.14h-.07A.48.48,0,0,0,240.52,405.3Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.27,311.9l-21.17,8.89c-8.75-21.75-20.65-32.21-20.65-32.21,8.48-10.17,24.14-14.85,24.14-14.85a27.83,27.83,0,0,1,5.91,6.64,59.51,59.51,0,0,1,4.6,8.59A121,121,0,0,1,207.27,311.9Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.37,259.42s6.65-6.78.28-11.25-12.69,1.5-12.69,1.5-15.13,3.81-11.81,13.86,5.44,10.88.69,16.1-9.59,12.92-4.63,17.77,22.06-.35,27.19-7.79S180.19,266.4,185.37,259.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.73,305.38l-23,7.89s5.09,25.05,8.78,29.24,28.36,23.59,31.85,22.06S250,342.51,250,342.51l-39.17-26.86Z",
    style: {
      fill: "#263238"
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.38 310.09 207.27 308.47 206.06 306.05 201.43 307.68 202.38 310.09"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.76 312.49 182.75 314.25 183.42 316.39 188.32 314.76 187.76 312.49"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "189.37 314.41 201.4 310.42 200.5 308 188.71 312.15 189.37 314.41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.1,289c-5.06-.59-7.91-8.2-7.91-8.2a27.68,27.68,0,0,1,3.31-.39A59.51,59.51,0,0,1,200.1,289Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.59,273.73c5.5-.82,17.8,3.64,18.87,3.59s13-9.43,13-9.43l3.1,2.73s-12.5,12.89-15.07,13-16-.86-16-.86-3.29-1.17-3.92-4.14A10.36,10.36,0,0,1,189.59,273.73Z",
    style: {
      fill: "#1EB445"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.1eaffa7655f1a44b453b240a5fa45adb.svg";
export { ForwardRef as ReactComponent };